//https://dev.to/ramonak/react-native-internationalization-with-i18next-568n
import en_translation from "./locales/en/translation.json";
import en_error from "./locales/en/errors.json";
import en_category from "./locales/en/categories.json";
import es_translation from "./locales/es/translation.json";
import es_error from "./locales/es/errors.json";
import es_category from "./locales/es/categories.json";
import fr_translation from "./locales/fr/translation.json";
import fr_error from "./locales/fr/errors.json";
import fr_category from "./locales/fr/categories.json";
import globe_en_translation from "./locales/33/en/translation.json";
import vodafone_en_translation from "./locales/43/en/translation.json";
import structuredClonePolyfill from "@ungap/structured-clone";

//If you ever need to add more languages, make sure to do that in ./middleware/language.server.mjs file.
function extractKeys<const T extends ReadonlyArray<{ key: string }>>(items: T) {
	return items.map(item => item.key) as { [K in keyof T]: T[K] extends { key: infer K } ? K : never };
}
export const LANGUAGE_NAMES = [
	{ key: "en", value: "English" },
	{ key: "es", value: "Español" },
	{ key: "fr", value: "Français" },
] as const;
export const SUPPORTED_LANGUAGES = extractKeys(LANGUAGE_NAMES);

export type TranslationType = typeof en_translation;
export type ErrorType = typeof en_error;
export type CategoryType = typeof en_category;
const clone = typeof structuredClone === "undefined" ? structuredClonePolyfill : structuredClone;
//@ts-ignore
export const resources = {
	global: {
		en: { translation: en_translation, error: en_error, category: en_category },
		es: { translation: es_translation, error: es_error, category: es_category },
		fr: { translation: fr_translation, error: fr_error, category: fr_category },
	},
	"33": {
		en: { translation: deepMerge(clone(en_translation), globe_en_translation), error: en_error, category: en_category },
		es: { translation: es_translation, error: es_error, category: es_category },
		fr: { translation: fr_translation, error: fr_error, category: fr_category },
	},
	"43": {
		en: { translation: deepMerge(clone(en_translation), vodafone_en_translation), error: en_error, category: en_category },
		es: { translation: es_translation, error: es_error, category: es_category },
		fr: { translation: fr_translation, error: fr_error, category: fr_category },
	},
} as {
	[key: string]: {
		en: { translation: typeof en_translation, error: typeof en_error, category: typeof en_category },
		es: { translation: typeof en_translation, error: typeof en_error, category: typeof en_category },
		fr: { translation: typeof en_translation, error: typeof en_error, category: typeof en_category },
	}
}

function isObject(item: any): item is Record<string, string | object> {
	return item && typeof item === "object" && !Array.isArray(item);
}
function deepMerge<T extends Record<string, string | object>>(target: T, ...sources: Partial<T>[]): T {
	if (!sources.length) return target;

	const source = sources.shift();
	if (source === undefined) return target;
	if (isObject(target) && isObject(source)) {
		Object.keys(source).forEach(key => {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				if (isObject(target[key])) {
					deepMerge(target[key], source[key]);
				}
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		})
	}
	return deepMerge(target, ...sources);
}
